// extracted by mini-css-extract-plugin
export var form = "_da-0";